import { useMemo } from 'react'

type Props = {
  scenarios: Record<string, string>[]
  pathname: string
}

const usePageTitle = ({ scenarios, pathname }: Props) => {
  const scenario = useMemo(() => {
    return scenarios.find((titleScenario) => {
      const testPath = titleScenario.path.replace('/:id', '')
      if (pathname === testPath) return true

      if (testPath === '/') return false

      return pathname.includes(testPath)
    })
  }, [pathname, scenarios])

  return scenario?.title
}

export default usePageTitle
